const MoneyMgmtChallenge2InitialText ="There are several advantages of keeping a monthly plan. " +
    "This plan tracks the total amount that you earn in a given month and the amount that you " +
    "plan to spend.  What are the main advantages of developing this type of plan? Move the Items " +
    "that you consider to be advantages of a monthly budget (plan) to the right hand column. " + 
    "When  you are finished, click the 'Done' button." 
       
export default MoneyMgmtChallenge2InitialText 
 